// extracted by mini-css-extract-plugin
export default {"div":"Contacts_div__DMpq5","title":"Contacts_title__ueeTm","list":"Contacts_list__2B760","item":"Contacts_item__uHSBb"};